import { render, staticRenderFns } from "./listitems.vue?vue&type=template&id=55e7a858&"
import script from "./listitems.vue?vue&type=script&lang=js&"
export * from "./listitems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports